// extracted by css-extract-rspack-plugin
var _1 = "ND08XGTWKwgws4A7";
var _2 = "vw7Ba2A4n0wwTbWn";
var _3 = "uFBNyA8R3Xo8UNGR";
var _4 = "dBXSnIyB15IURkG8";
var _5 = "OchSwn4oN5k6zlQM";
var _6 = "DQRxFHZqIUizo6Vc";
var _7 = "imwXW3kJD85FqJft";
var _8 = "pTd8nqKgUT8Uqaxn";
var _9 = "BsydJA8RELqzZ_5d";
export { _1 as "notification", _2 as "notificationClose", _3 as "notificationCloseContainer", _4 as "notificationContent", _5 as "notificationContentContainer", _6 as "notificationType", _7 as "notificationUnmountAnimation", _8 as "opacity0", _9 as "opacity100" }
